import { render, staticRenderFns } from "./OwnClassTeacherFilter.vue?vue&type=template&id=12520805&scoped=true&"
import script from "./OwnClassTeacherFilter.vue?vue&type=script&lang=js&"
export * from "./OwnClassTeacherFilter.vue?vue&type=script&lang=js&"
import style0 from "./OwnClassTeacherFilter.vue?vue&type=style&index=0&id=12520805&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12520805",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
